export var EnabledContactChannels;
(function (EnabledContactChannels) {
    EnabledContactChannels[EnabledContactChannels["TICKETING"] = 10] = "TICKETING";
    EnabledContactChannels[EnabledContactChannels["CALL_CENTER"] = 20] = "CALL_CENTER";
    EnabledContactChannels[EnabledContactChannels["CHAT"] = 30] = "CHAT";
    EnabledContactChannels[EnabledContactChannels["FACEBOOK"] = 40] = "FACEBOOK";
    EnabledContactChannels[EnabledContactChannels["WHATSAPP"] = 50] = "WHATSAPP";
    EnabledContactChannels[EnabledContactChannels["SMS"] = 60] = "SMS";
    EnabledContactChannels[EnabledContactChannels["KNOWLEDGEBASE"] = 70] = "KNOWLEDGEBASE";
    EnabledContactChannels[EnabledContactChannels["TWITTER"] = 80] = "TWITTER";
    EnabledContactChannels[EnabledContactChannels["INSTAGRAM"] = 90] = "INSTAGRAM";
})(EnabledContactChannels || (EnabledContactChannels = {}));
//# sourceMappingURL=enabled-contact-channels.enum.js.map